<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th>{{ i18n._729_TEAM_MEMBER | translate }}</th>
                <th>{{ i18n._797_OPPORTUNITY_ALIGNMENT | translate }}</th>
                <th>{{ i18n._732_CPC | translate }}</th>
                <th>{{ i18n._730_CAO | translate }}</th>
                <th>{{ i18n._798_MI2 | translate }}</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <td>{{ i.username }}</td>
                <td>{{ i.opportunityAlignment | percent: '1.0-0' }}</td>
                <td>{{ i.cpc | percent: '1.0-0' }}</td>
                <td>{{ i.cao | percent: '1.0-0' }}</td>
                <td>{{ i.mi2 | percent: '1.0-0' }}</td>
                <td class="text-center">
                    <button
                        type="button"
                        class="cmps-btn-table"
                        (click)="showDetails(i)"
                    >
                        <cmps-icon svgIcon="folder-outline"></cmps-icon>
                    </button>
                </td>
            </tr>
        </tbody>
        <tfoot class="tfoot-light">
            <tr>
                <th>{{ i18n._743_SUMMARY | translate }}</th>
                <th>
                    {{ data.overall.opportunityAlignment | percent: '1.0-0' }}
                </th>
                <th>{{ data.overall.cpc | percent: '1.0-0' }}</th>
                <th>{{ data.overall.cao | percent: '1.0-0' }}</th>
                <th>{{ data.overall.mi2 | percent: '1.0-0' }}</th>
                <th></th>
            </tr>
        </tfoot>
    </table>
</div>
